// @ts-nocheck
import styled from 'styled-components';
import type { StatelessFunctionalComponent } from 'react';
import { Dropdown } from 'components/Dropdown';
import { TABLET_WIDTH, TABLET_SMALL_WIDTH } from 'commons/constants/size';
import { getTheme } from 'settings/theme/index';
import LaunchIcon from '@mui/icons-material/Launch';

const {
  palette: { greyscale, primary, neutral },
  noodera: { fontTypes, spacing },
} = getTheme();

export const MobileHeaderContainer: StatelessFunctionalComponent<any> = styled.nav`
  min-height: 48px;
  padding: 0 ${spacing.x9} 0 ${spacing.x6};
  position: sticky;
  top: 0;
  z-index: 3;
  background: ${greyscale.white};
`;

export const SelectContainer: StatelessFunctionalComponent<any> = styled.div`
  margin-left: ${spacing.x6};
  display: flex;
  align-items: center;
  width: 100%;
  height: 24px;
  max-width: 60%;

  @media only screen and (max-width: ${TABLET_SMALL_WIDTH}px) {
    display: flex;
    flex-grow: 1;
  }
`;

export const LogoLink: StatelessFunctionalComponent<any> = styled.a`
  z-index: 1;

  & svg {
    height: 24px;
    width: auto;
  }

  p {
    display: inline-block;
    margin-bottom: 0;
    font-weight: 500;
    color: ${neutral.five};
  }
`;

export const StyledLogo: StatelessFunctionalComponent<any> = styled.img`
  max-height: 4.2rem;
`;

export const StyledLaunchIcon: StatelessFunctionalComponent<any> = styled(LaunchIcon)`
  &&& {
    font-size: 1.6rem;
    margin-right: ${spacing.x7};

    path {
      fill: ${primary.hundred};
    }
  }
`;

export const Heading: StatelessFunctionalComponent<any> = styled.div`
  width: 100%;
  min-height: 48px;
  display: flex;
  justify-content: space-between;

  @media only screen and (max-width: ${TABLET_WIDTH}px) {
    align-items: center;
    h1 {
      position: static;
      display: inline-block;
    }
  }
`;

export const ActionsContainer: StatelessFunctionalComponent<any> = styled.div`
  display: flex;
  align-items: center;
`;

export const LoadingContainer: StatelessFunctionalComponent<any> = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 100%;

  & > div {
    height: auto;
  }
`;

export const LoadingText: StatelessFunctionalComponent<any> = styled.span`
  ${fontTypes.font3};
  color: ${neutral.hundred};
`;

export const MobileHeaderActionsContainer: StatelessFunctionalComponent<any> = styled.div`
  display: flex;
  align-items: center;

  & > div,
  & > a > div {
    width: 2.4rem;
    height: 2.4rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  svg path {
    fill: ${neutral.eighty};
  }

  a:hover,
  a:focus,
  a:active {
    svg path {
      fill: ${primary.forty};
    }
  }
`;

export const StyledDropdown: StatelessFunctionalComponent<any> = styled(Dropdown)`
  color: ${neutral.eighty};

  div {
    margin-bottom: unset;
  }
  svg {
    display: ${(props) => (props.hideIcon ? 'none' : 'block')};

    path {
      fill: ${neutral.eighty};
    }
  }
`;

export const CompanyLogo: StatelessFunctionalComponent<any> = styled.img`
  max-height: 36px;
  width: auto;
`;
